import { render, staticRenderFns } from "./chat-room.vue?vue&type=template&id=2611329f&lang=pug&"
import script from "./chat-room.vue?vue&type=script&lang=js&"
export * from "./chat-room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports